import React from 'react'
import { IconCircleFilled } from '@tabler/icons-react'
import classNames from 'classnames'

export const PillBanner = ({ alertCount, color, labelText }) => {
  const status = alertCount > 0 ? color : 'neutral'

  return (
    <header className="alert-info_label">
      <IconCircleFilled
        size={8}
        className={classNames('alert-dot', `fill-${status}`)}
        data-testid={`pill-banner-dot-${status}`}
      />
      {`${alertCount} ${labelText}`}
    </header>
  )
}
